exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divBox[data-v-b55d65b6]{padding-bottom:0;margin-bottom:0}[data-v-b55d65b6] .el-tabs__header{margin-bottom:0}.form-wrapper[data-v-b55d65b6]{position:relative}[data-v-b55d65b6] .el-tabs__nav-wrap::after{display:none}.right-box[data-v-b55d65b6]{position:absolute;right:0;top:50%;width:300px;-webkit-transform:translateY(-50%);transform:translateY(-50%)}\n", ""]);

// exports
